webpackJsonp([41],{

/***/ 1504:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsRoughage_vue__ = __webpack_require__(1708);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a3dc7c7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsRoughage_vue__ = __webpack_require__(1757);
function injectStyle (ssrContext) {
  __webpack_require__(1755)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a3dc7c7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SettingsRoughage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a3dc7c7_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SettingsRoughage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1708:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(122);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
    props: ['systemId', 'systemName'],
    provide: {
        grid: [__WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["l" /* Sort */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["i" /* Page */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["g" /* Filter */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["m" /* Toolbar */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["k" /* Search */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["b" /* CommandColumn */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["j" /* PdfExport */], __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_vue_grids__["f" /* ExcelExport */]]
    },
    data: function data() {
        return {
            data: [],
            pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
            toolbar: [{ text: this.$t('SettingsRoughage'), id: 'table-settings-title' }, { text: this.$t('ClearFilter'), id: 'clear-filters', prefixIcon: 'e-cancel', align: 'Right' }, { text: this.$t('Excelexport'), prefixIcon: 'e-excelexport', align: 'Right', id: 'excel-export' }, { text: this.$t('Pdfexport'), prefixIcon: 'e-pdfexport', align: 'Right', id: 'pdf-export' }, { text: this.$t('Csvexport'), prefixIcon: 'e-csvexport', align: 'Right', id: 'csv-export' }, 'Search'],
            wrapSettings: { wrapMode: "Content" },
            selectionOptions: { type: "Multiple" },
            filterOptions: {
                type: "Menu"
            },
            customAttributes: { class: 'customcss' },
            sortingModes: [],
            dateTimeFormatOptions: { format: 'yyyy-MM-dd HH:mm:ss', type: 'dateTime' },
            decValueTemplate: function decValueTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('decValueTemplate', {
                        template: '\n                          <div v-if="data.weightUnit == 0 || data.weightUnit == -1">\n                            {{data.decValue}}g/s\n                          </div>\n                          <div v-else>\n                            {{data.decValue/1000}}lb/s\n                          </div>\n                      '
                    })
                };
            },
            incValueTemplate: function incValueTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('incValueTemplate', {
                        template: '\n                          <div v-if="data.weightUnit == 0 || data.weightUnit == -1">\n                            {{data.incValue}}g/s\n                          </div>\n                          <div v-else>\n                            {{data.incValue/1000}}lb/s\n                          </div>\n                      '
                    })
                };
            },
            maxEatingSpeedLogControlTemplate: function maxEatingSpeedLogControlTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('maxEatingSpeedLogControlTemplate', {
                        template: '\n                          <div v-if="data.weightUnit == 0 || data.weightUnit == -1">\n                            {{data.maxEatingSpeedLogControl}}g/s\n                          </div>\n                          <div v-else>\n                            {{data.maxEatingSpeedLogControl/1000}}lb/s\n                          </div>\n                      '
                    })
                };
            },
            calibrationWeightTemplate: function calibrationWeightTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('calibrationWeightTemplate', {
                        template: '\n                          <div v-if="data.weightUnit == 0 || data.weightUnit == -1">\n                            {{data.calibrationWeight}}kg\n                          </div>\n                          <div v-else>\n                            {{data.calibrationWeight}}lb\n                          </div>\n                      '
                    })
                };
            },
            noControlOfLogBelowValueTemplate: function noControlOfLogBelowValueTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('noControlOfLogBelowValueTemplate', {
                        template: '\n                          <div v-if="data.weightUnit == 0 || data.weightUnit == -1">\n                            {{data.noControlOfLogBelowValue}}g\n                          </div>\n                          <div v-else>\n                            {{data.noControlOfLogBelowValue/1000}}lb\n                          </div>\n                      '
                    })
                };
            },
            stabilisationGapTemplate: function stabilisationGapTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('stabilisationGapTemplate', {
                        template: '\n                          <div v-if="data.weightUnit == 0 || data.weightUnit == -1">\n                            {{data.stabilisationGap}}g\n                          </div>\n                          <div v-else>\n                            {{data.stabilisationGap/1000}}lb\n                          </div>\n                      '
                    })
                };
            },
            emptyMangerWeightTemplate: function emptyMangerWeightTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('emptyMangerWeightTemplate', {
                        template: '\n                          <div v-if="data.weightUnit == 0 || data.weightUnit == -1">\n                            {{data.emptyMangerWeight}}g\n                          </div>\n                          <div v-else>\n                            {{data.emptyMangerWeight/1000}}lb\n                          </div>\n                      '
                    })
                };
            },
            delayLogTemplate: function delayLogTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('delayLogTemplate', {
                        template: '\n                          <div>\n                            {{data.delayLogg}}s\n                          </div>\n                      '
                    })
                };
            },
            delayOpenTemplate: function delayOpenTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('delayOpenTemplate', {
                        template: '\n                          <div>\n                            {{data.delayOpen}}s\n                          </div>\n                      '
                    })
                };
            },
            stabilizationTimeTemplate: function stabilizationTimeTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('stabilizationTimeTemplate', {
                        template: '\n                          <div>\n                            {{data.stabilizationTime}}s\n                          </div>\n                      '
                    })
                };
            },
            wagonAutoCloseTimeTemplate: function wagonAutoCloseTimeTemplate() {
                return {
                    template: __WEBPACK_IMPORTED_MODULE_4_vue__["default"].component('wagonAutoCloseTimeTemplate', {
                        template: '\n                          <div>\n                            {{data.wagonAutoCloseTime}}s\n                          </div>\n                      '
                    })
                };
            }
        };
    },

    methods: {
        getData: function getData() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var roughageSettingsHistory;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _this.data = [];
                                _this.$emit('spin', true);

                                _context.next = 4;
                                return Object(__WEBPACK_IMPORTED_MODULE_2__api__["_47" /* getRoughageSettingsHistory */])(_this.systemId);

                            case 4:
                                roughageSettingsHistory = _context.sent;

                                _this.data = roughageSettingsHistory;
                                // console.log(this.data)
                                _this.$emit('spin', false);

                            case 7:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        },

        toolbarClick: function toolbarClick(args) {
            switch (args.item.id) {
                case "table-system-title":
                    this.$router.push({
                        name: "systems"
                    });
                    break;
                case "table-settings-title":
                    this.getData();
                    break;
                case "pdf-export":
                    this.$refs.grid.pdfExport();
                    break;
                case "csv-export":
                    this.$refs.grid.csvExport();
                    break;
                case "excel-export":
                    this.$refs.grid.excelExport();
                    break;
                case 'clear-filters':
                    this.$refs.grid.clearFiltering();
                    break;
            }
        },
        dataBound: function dataBound() {
            this.$refs.grid.autoFitColumns();
        }
    },
    mounted: function () {
        var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                while (1) {
                    switch (_context2.prev = _context2.next) {
                        case 0:
                            _context2.next = 2;
                            return this.getData();

                        case 2:
                        case 'end':
                            return _context2.stop();
                    }
                }
            }, _callee2, this);
        }));

        function mounted() {
            return _ref.apply(this, arguments);
        }

        return mounted;
    }()
});

/***/ }),

/***/ 1755:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1756);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(1502)("f587d8ea", content, true, {});

/***/ }),

/***/ 1756:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1501)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SettingsRoughage.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 1757:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100%","min-width":"1280px","padding":"10px"}},[_c('div',{staticStyle:{"display":"flex","flex-direction":"column","flex":"1","height":"100%","min-width":"1280px"}},[_c('ejs-grid',{ref:"grid",attrs:{"height":"100%","width":"100%","toolbar":_vm.toolbar,"toolbarClick":_vm.toolbarClick,"selectionSettings":_vm.selectionOptions,"allowTextWrap":true,"textWrapSettings":_vm.wrapSettings,"dataBound":_vm.dataBound,"dataSource":_vm.data,"allowPaging":true,"pageSettings":_vm.pageSettings,"allowFiltering":true,"filterSettings":_vm.filterOptions,"allowSorting":true,"allowMultiSorting":true,"allowPdfExport":true,"allowCsvExport":true,"allowExcelExport":true,"showBusyIndicator":true}},[_c('e-columns',[_c('e-column',{attrs:{"field":"updateDate","headerText":_vm.$t('UpdateDate'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"170","type":"datetime","format":_vm.dateTimeFormatOptions}}),_vm._v(" "),_c('e-column',{attrs:{"field":"delayLogg","headerText":_vm.$t('DelayLog'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"120","template":_vm.delayLogTemplate}}),_vm._v(" "),_c('e-column',{attrs:{"field":"decValue","headerText":_vm.$t('Dec.Value'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"130","template":_vm.decValueTemplate}}),_vm._v(" "),_c('e-column',{attrs:{"field":"incValue","headerText":_vm.$t('Inc.Value'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"120","template":_vm.incValueTemplate}}),_vm._v(" "),_c('e-column',{attrs:{"field":"delayOpen","headerText":_vm.$t('DelayOpen'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"130","template":_vm.delayOpenTemplate}}),_vm._v(" "),_c('e-column',{attrs:{"field":"stabilisationGap","headerText":_vm.$t('StabilizationGap'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"170","template":_vm.stabilisationGapTemplate}}),_vm._v(" "),_c('e-column',{attrs:{"field":"emptyMangerWeight","headerText":_vm.$t('MinMangerWeight'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"180","template":_vm.emptyMangerWeightTemplate}}),_vm._v(" "),_c('e-column',{attrs:{"field":"calibrationWeight","headerText":_vm.$t('CalibrationWeight'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"180","template":_vm.calibrationWeightTemplate}}),_vm._v(" "),_c('e-column',{attrs:{"field":"maxEatingSpeedLogControl","headerText":_vm.$t('MaxEatingSpeed'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"170","template":_vm.maxEatingSpeedLogControlTemplate}}),_vm._v(" "),_c('e-column',{attrs:{"field":"noControlOfLogBelowValue","headerText":_vm.$t('NoControlOfLogBelow'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"220","template":_vm.noControlOfLogBelowValueTemplate}}),_vm._v(" "),_c('e-column',{attrs:{"field":"stabilizationTime","headerText":_vm.$t('StabilizationTime'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"170","template":_vm.stabilizationTimeTemplate}}),_vm._v(" "),_c('e-column',{attrs:{"field":"wagonAutoCloseTime","headerText":_vm.$t('WagonAutoCloseTime'),"textAlign":"Left","customAttributes":_vm.customAttributes,"width":"210","template":_vm.wagonAutoCloseTimeTemplate}})],1)],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/41.dd8e61ed1c8d018fc8b9.js